import MDinput from '@/components/MDinput';
import PickRec from '@/components/DSE/PickRec';
import AddressInput from '@/components/DSE/AddressInput';
import { validatorEmail, validatorRequire } from '@/utils/validators';
import TimestampedRTE from '@/components/TimestampedRTE';
import CrudContactPerson from '../components/CrudContactPerson';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['supplier.tabGeneral', 'supplier.tabContactPersons'],
    headerTemplate: (str, form) => `
    <h3>
    ${form.name || ''}
    </h3>
    `,
    groups: [
      {
        // tab 1
        name: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 64,
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        code: {
          type: MDinput,
          props: {
            maxlength: 16,
            caption: 'supplier.code'
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        domainID: {
          type: PickRec,
          defaultValue: vue.$store.getters['domain/getDefaultSelectValueDomainID'],
          props: {
            caption: 'common.domain',
            valueField: 'id',
            labelField: 'name',
            inputField: 'name',
            maxlength: 64,
            columns: [{ field: 'name', label: 'common.name' }],
            entity: 'Domain',
            required: true,
            usePagination: true,
            hideInput: false,
            suggest: true
          },
          rules: [{ validator: validatorRequire }]
        },
        agentName: {
          type: MDinput,
          props: {
            maxlength: 64,
            caption: 'supplier.agentName'
          }
        },
        address: {
          type: AddressInput,
          props: {
            countries: vue.$store.getters['country/loadedItems'],
            countriesLoading: vue.$store.getters['country/isLoading']
          }
        },
        email: {
          type: MDinput,
          props: {
            type: 'email',
            maxlength: 64
          },
          rules: [{ validator: validatorEmail }]
        },
        phone: {
          type: MDinput,
          props: {
            type: 'tel'
          }
        },
        remarks: {
          type: TimestampedRTE,
          defaultValue: '',
          props: {
            caption: 'common.remarks'
          }
        }
      },
      {
        contactPersons: {
          type: CrudContactPerson,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'supplierID',
            permissionCode: 'Supplier'
          }
        }
      }
    ]
  };
}

const layoutTabGeneral = {
  named: true,
  sections: [
    {
      width: 50,
      fields: ['name', 'code', 'domainID', 'agentName']
    },
    {
      width: 50,
      fields: ['address', 'email', 'phone']
    },
    {
      width: 100,
      fields: ['remarks']
    }
  ]
};
const layoutFullWidth = {
  sections: [
    {
      width: 100
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutFullWidth]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
